export default "__VITE_ASSET__D5Wv_jnK__"